import Dexie from "dexie";
import { useEffect, useState } from "react";
import {ipcInvoke, ipcSend} from '@/common/ipc';

let img;

export function initImg(db) {
    // img = db.table('img')
}

/** 新增 */
export async function addImg(id, data) {
    // img.add({ id, data })
    await ipcSend('note-img', id, data)
}

/** 修改 */
export function editImg(id, data) {
    // img.put({ id, data })
    ipcSend('note-img', id, data)
}


/** 删除 */
export function delImg(id) {
    // img.delete(id)
    ipcSend('note-img-delete', id)
}

// export function getImg(id) {
//     return img.where('id')
//         .equals(id)
//         .toArray()
// }

// export function useImg(id) {
//     const [img, setImg] = useState<string>('')
//     useEffect(() => {
//         getImg(id).then((r) => {
//             setImg(r[0]?.data)
//         })
//     }, [id])
//     return img
// }
/** 获取图片的base64 */
export function getImgById(id) {
    return ipcInvoke('get-img-by-id', id)
}